import { render, staticRenderFns } from "./rightcolumn.vue?vue&type=template&id=9c206a92&scoped=true&"
import script from "./rightcolumn.vue?vue&type=script&lang=js&"
export * from "./rightcolumn.vue?vue&type=script&lang=js&"
import style0 from "./rightcolumn.vue?vue&type=style&index=0&id=9c206a92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c206a92",
  null
  
)

export default component.exports